import React, { useEffect, useState } from 'react';
import Select from '@material-ui/core/Select';
import {
  Accordion,
  AccordionSummary,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { dominioLeanAspNetAPI } from 'config/database';
import { ProgressSpinner } from 'primereact/progressspinner';
import Button from 'components/CustomButtons/Button';
import { format } from 'date-fns';
import '../../assets/css/report.css';
import { isAxiosError } from 'axios';

export default function Relatorio() {
  const listaUnidadeTecnica = [{ id: 1, nome: 'HC I' }, { id: 2, nome: 'HC II' }];

  const [unidadeTecnicaSelecionadaId, setUnidadeTecnicaSelecionadaId] = useState(
    listaUnidadeTecnica[0].id
  );

  const [listaAlas, setListaAlas] = useState([]);
  const [alaSelecionada, setAlaSelecionada] = useState('');
  const [alaFiltro, setAlaFiltro] = useState('');
  const [selectedDateInicio, setSelectedDateInicio] = useState(
    new Date().toISOString().split('T')[0]
  );
  const [selectedDateFim, setSelectedDateFim] = useState(new Date().toISOString().split('T')[0]);
  const [nomeMunicipio, setNomeMunicipio] = useState('');
  const [carregar, setCarregar] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [dadosRelatorio, setDadosRelatorio] = useState([]);
  const [mensagemErro, setMensagemErro] = useState(null);

  useEffect(() => {
    const getListaAlas = async () => {
      setCarregar(true);
      try {
        const response = await dominioLeanAspNetAPI.post('/api/listarAlas', {
          seqUnidadeTecnica: unidadeTecnicaSelecionadaId,
        });

        let alas = response.data;

        alas = [{ seqAla: 'todos', nome: 'TODOS' }, ...alas];
        setListaAlas(alas);

        if (!alas.find(a => a.seqAla === alaSelecionada)) {
          setAlaSelecionada(alas[0]?.seqAla ?? '');
        }
      } catch (error) {
        console.error('Erro ao carregar alas:', error);
      } finally {
        setCarregar(false);
      }
    };

    getListaAlas();
    setShowResults(false);
  }, [unidadeTecnicaSelecionadaId]);

  const removeAcentos = txtCidade => {
    if (!txtCidade) return '';

    return txtCidade.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  const handleBuscar = async event => {
    event.preventDefault();
    setCarregar(true);
    setShowResults(false);
    setMensagemErro(null);

    const today = new Date().toISOString().split('T')[0];
    const startDate = new Date(`${selectedDateInicio}T00:00:00`);
    const endDate = new Date(`${selectedDateFim}T23:59:59.999`);

    if (selectedDateInicio > today || selectedDateFim > today) {
      alert(`
        A data ${
          selectedDateInicio > today ? 'início' : 'fim'
        } selecionada não pode estar no futuro.`);
      setCarregar(false);
      return;
    }

    if (endDate < startDate) {
      alert('A data de fim não pode ser menor que a data de início.');
      setCarregar(false);
      return;
    }

    const filtros = {
      seqUnidadeTecnica: unidadeTecnicaSelecionadaId,
      seqAla: alaSelecionada !== 'todos' ? alaSelecionada : '',
      dataInicio: startDate.toISOString(),
      dataFim: endDate.toISOString(),
      ...(nomeMunicipio.trim() && { municipio: removeAcentos(nomeMunicipio.trim().toUpperCase()) }),
    };

    try {
      const response = await dominioLeanAspNetAPI.post('/api/filtroRelatorio', filtros);
      const resultado = response.data;

      if (resultado !== null) {
        setDadosRelatorio(resultado);
        setAlaFiltro(alaSelecionada);
        setShowResults(true);
        // console.log('response', response);
      } else {
        setDadosRelatorio([]);
        setShowResults(true);
        setMensagemErro(null);
      }
    } catch (error) {
      console.error('Erro ao buscar resultados:', error);
      setDadosRelatorio([]);
    } finally {
      setCarregar(false);
      setMensagemErro(null);
    }
  };

  const handleLimpar = () => {
    setSelectedDateInicio(new Date().toISOString().split('T')[0]);
    setSelectedDateFim(new Date().toISOString().split('T')[0]);
    setUnidadeTecnicaSelecionadaId(listaUnidadeTecnica[0].id);
    setAlaSelecionada('todos');
    setNomeMunicipio('');
    setShowResults(false);
  };

  const handleImprimir = async () => {
    try {
      setCarregar(true);

      const startDate = new Date(`${selectedDateInicio}T00:00:00`);
      const endDate = new Date(`${selectedDateFim}T23:59:59.999`);

      const data = {
        seqUnidadeTecnica: unidadeTecnicaSelecionadaId,
        seqAla: alaSelecionada !== 'todos' ? alaSelecionada : '',
        dataInicio: startDate.toISOString(),
        dataFim: endDate.toISOString(),
        ...(nomeMunicipio.trim() && {
          municipio: removeAcentos(nomeMunicipio.trim().toUpperCase()),
        }),
      };

      const response = await dominioLeanAspNetAPI.post('/api/filtroRelatorio/imprimir', data, {
        responseType: 'blob',
      });

      if (response) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        window.open(URL.createObjectURL(blob), '_blank');
      } else {
        setShowResults(true);
      }

      setMensagemErro(null);

      // console.log('response', response);
    } catch (error) {
      if (error.response?.data instanceof Blob) {
        const errorText = await error.response.data.text();
        const errorJson = JSON.parse(errorText);

        if (errorJson) {
          setMensagemErro(errorJson.mensagem);
          console.error('errorJson', errorJson.mensagem);
        }
      }
    } finally {
      setCarregar(false);
      setShowResults(true);
    }
  };

  const abreviar = nome => {
    if (!nome) return '';

    return nome
      .trim()
      .split(/\s+/)
      .map(names => `${names.charAt(0).toUpperCase()}.`)
      .join(' ');
  };

  if (carregar) {
    return <ProgressSpinner style={{ left: '45%' }} />;
  }

  return (
    <>
      <form onSubmit={handleBuscar}>
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          className="grid-report-filter"
        >
          <Grid item sm={12} lg fullWidth className="grid-report-filter-inputs">
            <FormControl
              fullWidth
              style={{
                maxWidth: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              <InputLabel id="unidade-tecnica" className="label-reports">
                Unidade
              </InputLabel>
              <Select
                id="unidade-tecnica"
                label="Unidade Tecnica"
                labelId="unidade-tecnica"
                value={unidadeTecnicaSelecionadaId}
                onChange={e => setUnidadeTecnicaSelecionadaId(e.target.value)}
              >
                {listaUnidadeTecnica.map(unidadeTecnica => (
                  <MenuItem value={unidadeTecnica.id} key={unidadeTecnica.id}>
                    {unidadeTecnica.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              style={{
                maxWidth: '300px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              <InputLabel id="alas" className="label-reports">
                Alas
              </InputLabel>
              <Select
                id="alas"
                label="Alas"
                labelId="Alas"
                value={alaSelecionada}
                onChange={e => setAlaSelecionada(e.target.value)}
                style={{
                  textTransform: 'uppercase',
                }}
              >
                {listaAlas.map(alas => (
                  <MenuItem value={alas.seqAla} key={alas.seqAla}>
                    {alas.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              style={{
                width: '140px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              id="dateInicio"
              type="date"
              label="Data início Epícrise"
              value={selectedDateInicio}
              onChange={e => setSelectedDateInicio(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              style={{
                width: '140px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
              id="dateFim"
              label="Data fim Epícrise"
              type="date"
              value={selectedDateFim}
              onChange={e => setSelectedDateFim(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
            <FormControl fullWidth style={{ maxWidth: '360px', marginBottom: '16px' }}>
              <TextField
                type="text"
                labelId="municipio"
                id="municipio"
                label="Município"
                onChange={e => setNomeMunicipio(e.target.value)}
                value={nomeMunicipio}
                fullWidth
              />
            </FormControl>
          </Grid>
          <Grid
            item
            sm={12}
            lg
            fullWidth
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              maxWidth: '410px',
              flexWrap: 'wrap',
            }}
            className="grid-report-filter-btn"
          >
            <Button type="submit" variant="outlined" color="info">
              Buscar
            </Button>
            <Button onClick={handleLimpar} type="button" color="rose" style={{ margin: '5px 8px' }}>
              Limpar
            </Button>
            <Button
              onClick={handleImprimir}
              variant="contained"
              color="primary"
              style={{ background: '#155dfc' }}
            >
              Emitir Relatório
            </Button>
          </Grid>
        </Grid>
      </form>

      {dadosRelatorio.length > 0 &&
        showResults &&
        listaAlas
          .filter(ala => {
            if (alaFiltro === 'todos') return ala.seqAla !== 'todos';
            return ala.seqAla === alaFiltro;
          })
          .map(ala => {
            const dadosDaAla = dadosRelatorio.filter(dado => dado.SeqAla === ala.seqAla);

            return (
              <Accordion
                key={ala.seqAla}
                style={{ padding: '10px', margin: '5px' }}
                defaultExpanded="true"
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className="report-name-ala">{ala.nome}</Typography>
                </AccordionSummary>

                {dadosDaAla.length > 0 ? (
                  <Grid container>
                    <TableContainer style={{ padding: '30px' }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Número Prontuário</TableCell>
                            <TableCell align="center">Nome Paciente</TableCell>
                            <TableCell align="center">Município</TableCell>
                            <TableCell align="center">Leito</TableCell>
                            <TableCell align="center">Data/hora Solicitação Transporte</TableCell>
                            <TableCell align="center">Data/hora Saída da Recepção</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dadosDaAla.map(dado => (
                            <TableRow key={dado.SeqAla}>
                              <TableCell align="center">{dado.NroProntuario}</TableCell>
                              <TableCell align="center">{abreviar(dado.NomPaciente)}</TableCell>
                              <TableCell align="center">{dado.NomMunicipio}</TableCell>
                              <TableCell align="center">{dado.CodLeito}</TableCell>
                              <TableCell align="center">
                                {dado.DatHoraTransporte
                                  ? format(new Date(dado.DatHoraTransporte), 'dd/MM/yyyy HH:mm')
                                  : ' - '}
                              </TableCell>
                              <TableCell align="center">
                                {dado.DatHoraSaida
                                  ? format(new Date(dado.DatHoraSaida), 'dd/MM/yyyy HH:mm')
                                  : ' - '}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                ) : (
                  <span style={{ padding: '10px', fontSize: '16px' }}>Nenhum dado encontrado.</span>
                )}
              </Accordion>
            );
          })}

      {showResults && (mensagemErro || dadosRelatorio.length === 0) && (
        <span
          style={{
            padding: '20px',
            display: 'block',
            margin: '15px 0',
            textAlign: 'center',
            fontWeight: '600',
            background: '#FFF',
            borderRadius: '5px',
          }}
        >
          {mensagemErro || 'Nenhum dado encontrado para os filtros informados.'}
        </span>
      )}
    </>
  );
}
